

import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { backendUrl, currency } from '../App';
import { toast } from 'react-toastify';

const List = ({token}) => {
  const [list, setList] = useState([]);

  const fetchlist = async () => {
    try {
      const response = await axios.get(backendUrl + '/api/product/list');

      if (response.data.success) {
        setList(response.data.products);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    }
  };

  const removeproduct = async (id) =>{
    try{

      const response = await axios.post(backendUrl + '/api/product/remove',{id},{headers:{token}});

      if(response.data.success){
        toast.success(response.data.message);
        await fetchlist();
      }
      else{
        toast.error(response.data.message);
      }
    }
    catch(error){
      console.log(error);
      toast.error(error.message);
    }
  }

  useEffect(() => {
    fetchlist();
  }, []);

  return (
    <div className="container mt-4">
      <p className="mb-3 fw-bold">All Products List</p>

      <div className="table-responsive">
        <table className="table table-bordered text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th scope="col">Image</th>
              <th scope="col">Name</th>
              <th scope="col">Category</th>
              <th scope="col">Price</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {list.map((item, index) => (
              <tr key={index}>
                <td>
                  <img src={item.image[0]} alt={item.name} className="img-fluid" style={{ maxWidth: '50px', height: 'auto' }} />
                </td>
                <td>{item.name}</td>
                <td>{item.category}</td>
                <td>{currency}{item.price}</td>
                <td>
                  <button onClick={()=>removeproduct(item._id)} className="btn btn-danger btn-sm">X</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
};

export default List;
